module.exports = __webpack_public_path__ + "static/media/search.effd37e3.svg";